import React from 'react';
import styled from 'styled-components/native';
import { TextProps as RNTextProps } from 'react-native';
import { Theme } from '@theme/aiaTheme';

type TypographyVariant =
  | 'display'
  | 'headline'
  | 'title'
  | 'titleMedium'
  | 'body'
  | 'bodyMedium'
  | 'bodySmall'
  | 'caption'
  | 'button'
  | 'buttonSmall';

interface TextProps extends RNTextProps {
  variant?: TypographyVariant;
  color?: keyof Theme['colors'];
  align?: 'left' | 'center' | 'right' | 'justify';
  children: React.ReactNode;
}

const StyledText = styled.Text<TextProps>`
  color: ${({ theme, color }) => theme.colors[color || 'textPrimary']};
  font-size: ${({ theme, variant = 'body' }) => theme.typography[variant].fontSize}px;
  line-height: ${({ theme, variant = 'body' }) => theme.typography[variant].lineHeight}px;
  font-weight: ${({ theme, variant = 'body' }) => theme.typography[variant].fontWeight};
  letter-spacing: ${({ theme, variant = 'body' }) => theme.typography[variant].letterSpacing}px;
  text-align: ${({ align = 'left' }) => align};
`;

export const Text: React.FC<TextProps> = ({ children, ...props }) => (
  <StyledText {...props}>{children}</StyledText>
);
